/**
 * The port name identifies a port everywhere in the app: it is what the selector
 * shows, what travels as the selected port (tabInfo.port is a string) and what
 * getSerialPortByName and findAgentPortByName resolve back to a board.
 *
 * Two boards of the same model report the same vendor and product id, so the name
 * built out of them is the same for both. The reducer then drops one of them when
 * merging the sources, and both lookups above answer with the first match, so the
 * second board cannot be selected, flashed or reported apart from the first one. A
 * suffix keeps every name unique within the agent that owns the list.
 *
 * The name is assigned once, when the entry is created, and is never changed
 * afterwards: the traceability diff keys ports by name, so a name that mutated
 * would read as one board leaving and another arriving.
 */
export const uniquePortName = (baseName, ports) => {
  const taken = new Set((ports || []).map((port) => port && port.Name));
  if (!taken.has(baseName)) return baseName;
  let suffix = 2;
  while (taken.has(`${baseName} (${suffix})`)) suffix += 1;
  return `${baseName} (${suffix})`;
};

/**
 * A port whose descriptor has no usb ids (a bluetooth or a plain system serial
 * port) still gets a name, and 'unknown' marks it as a port that cannot be
 * matched against a usb device.
 */
export const usbIdToHex = (id) => ((typeof id === 'number') ? `0x${id.toString(16).padStart(4, '0')}` : 'unknown');
